import { PUBLIC_HOSTS } from '../constant'
import type { HOST, HOSTKEY } from '../constant'
import { isKdocsHost, isServer } from '../util'

let publicHosts: {
  -readonly [k in HOSTKEY]: HOST[k]
} | { [k: string]: string } = {...PUBLIC_HOSTS}

export interface Service {
  encryption: boolean
  host: string
  insecure: boolean
  path: string
  port: number | string
  scheme: 'https' | 'http'
}

export interface AddressesInterface {
  [k: string]: Service
}

export const REAL_KDOCS_HOSTS = [
  'test-edu.kdocs.cn',
  'edu.kdocs.cn',
  'pc.kdocs.cn',
  'qr.kdocs.cn',
  'internal.kdocs.cn',
  'docs.kdocs.cn',
  'www.kdocs.cn',
  'meeting.kdocs.cn',
  'plussvr.kdocs.cn',
  'dc.kdocs.cn',
  'docer.kdocs.cn',
  'docer-vcl.kdocs.cn',
  'vipapi.kdocs.cn',
  'plus.kdocs.cn',
  'pub.kdocs.cn',
  'rili.kdocs.cn',
  'f.kdocs.cn',
  'securitydoc.kdocs.cn',
  'hd.kdocs.cn',
  'docer-mo.kdocs.cn',
]

export function isCustomDomain () {
  if (isServer()) return false
  // 自定义域名下的KDOCS, 默认为当前页面的hostname
  const host = (typeof window !== 'undefined' && typeof location !== 'undefined' && location.host) || ''
  return (host && !~REAL_KDOCS_HOSTS.indexOf(host) && /^([\s\S]+?)\.(kdocs\.cn)$/.test(host)) || false // 是否为自定义域名
}

export function isBackupDomain () {
  if (isServer()) return false
  // 自定义域名下的KDOCS, 默认为当前页面的hostname
  const host = (typeof window !== 'undefined' && typeof location !== 'undefined' && location.host) || ''

  return (host && ['www.kdoc.cn', 'docs.kdocs.cn'].includes(host))
}

export function createService (override: Partial<Service>): Service {
  return {
    encryption: false,
    insecure: true,
    host: '',
    path: '',
    port: '',
    scheme: 'https',
    ...override,
  }
}

export function createPublicAddresses () {
  const addresses: AddressesInterface = {}

  /**
   * @description 在kdocs域名，部分.wps.cn结尾的域名需要更换成kdocs.cn
   * @todo 建议确认下是不是所有的域名都可以进行.kdocs.cn和.wps.cn的切换，如果可以，统一在kdocs.cn域名下的所有服务都进行切换
   */
  if (isKdocsHost()) {
    publicHosts.RILI = 'rili.kdocs.cn'
    publicHosts.FORM = 'f.kdocs.cn'
    publicHosts.SECURITYDOC = 'securitydoc.kdocs.cn'
    publicHosts.HD = 'hd.kdocs.cn'
    publicHosts.FORMAPI = 'f-api.kdocs.cn'
    publicHosts.PAYCONFIGAPI = 'docer-api.kdocs.cn'
    publicHosts.PAYAPI = 'pay.kdocs.cn'
    publicHosts.VIPCASHDESK = 'vipapi.kdocs.cn'
    publicHosts.VAS2T = 'vas2t-api.kdocs.cn'
  }

  // 自定义域名的情况下特殊处理
  if (isCustomDomain() || isBackupDomain()) {
    const host = (typeof window !== 'undefined' && typeof location !== 'undefined' && location.host) || ''
    publicHosts.KDOCS = host
  }

  // 备用域名的情况下特殊处理
  if (isBackupDomain()) {
    publicHosts.TWPS = 't.kdocs.cn'
    publicHosts.FORMAPI = 'f-api.kdocs.cn'
  }

  for (const key in publicHosts) {
    addresses[key] = createService({ host: publicHosts[key] })
  }

  return addresses
}

export function getPublicHostKey (hostKey: HOSTKEY | Lowercase<HOSTKEY>) {
  return hostKey
}
